import { CALL_INDEX, CALL_SAVE } from '../actions/call'
import apiCall from '../../utils/api'

const state = {
  calls: []
}

const getters = {
  [CALL_INDEX]: (state, getters) => {
    return state.calls
  }
}

const actions = {
  [CALL_INDEX]: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      apiCall({url: 'api/calls', method: 'GET'})
        .then(resp => {
          commit(CALL_INDEX, resp)
          resolve(resp)
        })
    })
  },
  [CALL_SAVE]: ({commit, dispatch}, data) => {
    return new Promise((resolve, reject) => {
      apiCall({url: 'api/calls', method: 'POST', ...data}).then(resp => {
        // commit(TIMEENTRY_ADD, resp.data)
        resolve(resp.data)
      }).catch(err => {
        reject(err)
      })
    })
  }
}

const mutations = {
  [CALL_INDEX]: (state, resp) => {
    state.calls = resp
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/call.js